import api from '@/services/api'

export default function(store) {
  store.$api = api
}
